
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import IconButton from '@/components/shared/suites/IconButton.vue';

type SortDirection = 'asc' | 'desc' | null;

@Component<AlphabeticalSortButton>({
	components: {
		IconButton
	}
})
export default class AlphabeticalSortButton extends Vue {
	@Prop({ type: String, required: true }) private id!: string;
	@Prop({ type: String, default: null }) private value!: SortDirection;

	private get isActive(): boolean {
		return this.value !== null;
	}

	private get icon(): string {
		switch (this.value) {
			case 'asc':
				return 'mdi-sort-alphabetical-ascending';
			case 'desc':
				return 'mdi-sort-alphabetical-descending';
			default:
				return 'mdi-sort-alphabetical-variant';
		}
	}

	private get tooltip(): TranslateResult {
		switch (this.value) {
			case 'asc':
				return this.$t('orders.sort.ascending');
			case 'desc':
				return this.$t('orders.sort.descending');
			default:
				return this.$t('orders.sort.default');
		}
	}

	private cycle(): void {
		if (this.value === null) {
			this.$emit('input', 'asc');
			return;
		}
		if (this.value === 'asc') {
			this.$emit('input', 'desc');
			return;
		}
		this.$emit('input', null);
	}
}
